import React from "react";
import { MaskedText, SectionLabel } from "./MaskedText";

export function ExperienceSection({ experience }) {
  return (
    <section className="section experience" id="experience">
      <div className="page-width">
        <SectionLabel number="03 /">My experience</SectionLabel>
        <div className="experience__list">
          {experience.map((item, index) => (
            <article className="experience-row" key={`${item.role}-${item.period}`} tabIndex="0">
              <span className="experience-row__line" data-experience-line />
              <small>{String(index + 1).padStart(2, "0")}</small>
              <div className="experience-row__main">
                <span>{item.company}</span>
                <MaskedText as="h2" data-experience-title>{item.role}</MaskedText>
              </div>
              <div className="experience-row__meta">
                <strong>{item.period}</strong>
                <p>{item.detail}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
